import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import Container from "@/components/containers/Container";
import Tab from "@/components/containers/tabs/Tab";
import TabGroup from "@/components/containers/tabs/TabGroup";
import TabList from "@/components/containers/tabs/TabList";
import TabPanel from "@/components/containers/tabs/TabPanel";
import TabPanels from "@/components/containers/tabs/TabPanels";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import PeriodReportDetails from "@/modules/recognition/admin/components/PeriodReportDetails";
import PeriodReportOverview from "@/modules/recognition/admin/components/PeriodReportOverview";
import { fetchPeriodQueryOptions } from "@/modules/recognition/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_recognition/recognition/period-reports/$id",
)({
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "recognition.recognition-period.view");

    return {
      crumb: [
        {
          label: context.t("Period Reports", { ns: "recognition.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchPeriodQueryOptions(opts.params.id),
    ),

  stringifyParams: ({ id }) => ({ id: `${id}` }),
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("recognition.admin");
  const { id } = Route.useParams();

  return (
    <Container title={t("Period Reports")}>
      <TabGroup>
        <div className="flex items-end gap-7">
          <TabList className="min-w-0 flex-1">
            <Tab>{t("Period Overview")}</Tab>
            <Tab>{t("Appercations Details")}</Tab>
          </TabList>
        </div>
        <TabPanels>
          <TabPanel>
            <PeriodReportOverview id={id} />
          </TabPanel>
          <TabPanel>
            <PeriodReportDetails />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </Container>
  );
}
